export const buildAuthUserMenus = ({ authUser, gotoMyAccount, groupMainte, logout }) => {
  const menu = [
    {
      icon: 'mdi-account',
      text: 'マイアカウント',
      action: gotoMyAccount,
      authority: 0,
    },
    {
      icon: 'mdi-account-group',
      text: 'グループ管理',
      action: groupMainte,
      authority: 1,
    },
    {
      icon: 'mdi-exit-to-app',
      text: 'ログアウト',
      action: logout,
      authority: 0,
    },
  ]

  return menu.filter(
    item => item.authority <= (authUser ? authUser.authority : 0)
  )
}

export const buildNavMenus = ({
  authUser,
  totalQty,
  gotoTop,
  gotoOrder,
  groupMainte,
  gotoAbout,
  gotoTerms,
  gotoPolicy,
  gotoLaw,
  gotoMyAccount,
  logout,
  masterMainte,
  noticeMainte,
}) => {
  const menu = [
    {
      type: 'item',
      icon: 'mdi-home-outline',
      text: 'トップページ',
      action: gotoTop,
      auth: false,
    },
    {
      type: 'item',
      icon: 'mdi-cart-outline',
      text: 'カート',
      action: gotoOrder,
      auth: false,
      badgeCounter: totalQty,
    },
    {
      type: 'item',
      icon: 'mdi-account-group',
      text: 'グループ管理',
      action: groupMainte,
      auth: true,
      authLevel: 1,
    },
    { type: 'devider' },
    {
      type: 'item',
      icon: 'mdi-information-outline',
      text: '余韻の米蔵について',
      action: gotoAbout,
      auth: false,
    },
    {
      type: 'item',
      icon: 'mdi-information-outline',
      text: '利用規約',
      action: gotoTerms,
      auth: false,
    },
    {
      type: 'item',
      icon: 'mdi-information-outline',
      text: 'プライバシーポリシー',
      action: gotoPolicy,
      auth: false,
    },
    {
      type: 'item',
      icon: 'mdi-information-outline',
      text: '特商法に基づく表記',
      action: gotoLaw,
      auth: false,
    },
    { type: 'devider' },
    {
      type: 'item',
      icon: 'mdi-account',
      text: 'マイアカウント',
      action: gotoMyAccount,
      auth: true,
      authLevel: 0,
    },
    {
      type: 'item',
      icon: 'mdi-exit-to-app',
      text: 'ログアウト',
      action: logout,
      auth: true,
      authLevel: 0,
    },
  ]

  if (authUser && authUser.id == 1) {
    menu.push({
      type: 'item',
      icon: 'mdi-cog',
      text: '商品マスタメンテナンス',
      action: masterMainte,
      auth: true,
      authLevel: 1,
    })
    menu.push({
      type: 'item',
      icon: 'mdi-cog',
      text: 'お知らせ表示メンテナンス',
      action: noticeMainte,
      auth: true,
      authLevel: 1,
    })
  }

  return menu.filter(
    item =>
      item.type == 'divider' ||
      !item.auth ||
      (item.auth &&
        authUser &&
        item.authLevel <= authUser.authority)
  )
}
